var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-row",
        { attrs: { justify: "center" } },
        [
          _c(
            "v-dialog",
            {
              staticClass: "modal_medium",
              attrs: { "content-class": "v-dialog--custom", persistent: "" },
              model: {
                value: _vm.visible,
                callback: function ($$v) {
                  _vm.visible = $$v
                },
                expression: "visible",
              },
            },
            [
              _c(
                "v-card",
                [
                  _c(
                    "v-form",
                    {
                      ref: "form",
                      attrs: {
                        method: "post",
                        enctype: "multipart/form-data",
                        "lazy-validation": "",
                      },
                      model: {
                        value: _vm.valid,
                        callback: function ($$v) {
                          _vm.valid = $$v
                        },
                        expression: "valid",
                      },
                    },
                    [
                      _c("v-card-title", [
                        _c("span", { staticClass: "headl" }, [
                          _vm._v("REPORTE DE INTEGRADORES"),
                        ]),
                      ]),
                      _c(
                        "v-card-text",
                        [
                          _c(
                            "v-container",
                            [
                              _c(
                                "v-row",
                                [
                                  _c(
                                    "v-col",
                                    {
                                      attrs: { cols: "12", sm: "12", md: "12" },
                                    },
                                    [
                                      _c("p", [
                                        _vm._v(
                                          " Seleccionar la empresa para exportar sus integradores. "
                                        ),
                                      ]),
                                      _vm.msjError
                                        ? _c(
                                            "v-alert",
                                            {
                                              staticClass: "alert_custom",
                                              attrs: { type: "warning" },
                                            },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "ctn_alert" },
                                                [
                                                  _c(
                                                    "v-btn",
                                                    {
                                                      attrs: {
                                                        color: "#000",
                                                        icon: "",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          _vm.textInfo.flag = 0
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c("v-icon", [
                                                        _vm._v("mdi-close"),
                                                      ]),
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "p",
                                                    {
                                                      staticClass:
                                                        "ctn_alert_text",
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.textInfo.text
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-col",
                                    {
                                      attrs: { cols: "12", sm: "12", md: "12" },
                                    },
                                    [
                                      _c("v-combobox", {
                                        ref: "company",
                                        attrs: {
                                          items: _vm.itemsData,
                                          "search-input": _vm.search,
                                          "item-value": "_id",
                                          "item-text": "name",
                                          label: "Empresas",
                                          placeholder:
                                            "Digite el nombre de la empresa",
                                          clearable: "",
                                          rules: _vm.nameRules,
                                        },
                                        on: {
                                          "update:searchInput": function (
                                            $event
                                          ) {
                                            _vm.search = $event
                                          },
                                          "update:search-input": function (
                                            $event
                                          ) {
                                            _vm.search = $event
                                          },
                                          change: _vm.actionClear,
                                        },
                                        model: {
                                          value: _vm.form.company,
                                          callback: function ($$v) {
                                            _vm.$set(_vm.form, "company", $$v)
                                          },
                                          expression: "form.company",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-card-actions",
                        [
                          _c("v-spacer"),
                          _c(
                            "div",
                            { staticClass: "ctn_btn_shop" },
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: { large: "", text: "" },
                                  on: { click: this.closeModal },
                                },
                                [_vm._v("Cerrar")]
                              ),
                              _vm.hideBtn == false
                                ? _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        disabled: _vm.isDisable,
                                        large: "",
                                        color: "primary",
                                      },
                                      on: { click: _vm.validate },
                                    },
                                    [_vm._v("Validar ")]
                                  )
                                : _vm._e(),
                              _vm.visibleBtn == true
                                ? _c(
                                    "download-csv",
                                    {
                                      staticClass: "btn btn-default",
                                      attrs: {
                                        data: _vm.response,
                                        name: "reporte_integradores.csv",
                                      },
                                    },
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            large: "",
                                            color: "primary",
                                          },
                                          on: { click: this.registerForm },
                                        },
                                        [_vm._v("DESCARGAR")]
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }